import React, { useState } from "react";
import BarcodeScannerComponent from "react-barcode-reader";
import axios from "axios";

const BarcodeScanner = () => {
    const [scannedData, setScannedData] = useState(null);
    const [error, setError] = useState(null);

    const handleScan = async (tokenId) => {
        if (!tokenId) return;
        
        try {
            // Make an API request to fetch details based on scanned Token ID
            const response = await axios.post("https://chaman.gob.pk/eac_backend/barcode/marriage.php", {
                action: "fetch_by_token",
                token_id: tokenId,
            });

            if (response.data && response.data.status === "success") {
                setScannedData(response.data.record); // Store fetched data
            } else {
                setScannedData(null);
                setError("No record found for this Token ID.");
            }
        } catch (err) {
            setError("Error fetching details. Try again.");
        }
    };

    return (
        <div>
            <h2>Scan Barcode</h2>
            <BarcodeScannerComponent
                onError={(err) => console.error(err)}
                onScan={(data) => handleScan(data)}
            />
            
            {error && <p style={{ color: "red" }}>{error}</p>}

            {scannedData && (
                <div>
                    <h3>Scanned Details:</h3>
                    <p><strong>Mr. {scannedData.name}</strong></p>
                    <p>Application for <strong>{scannedData.form_type}</strong> is issued by the <strong>Deputy Commissioner Office, Chaman</strong>.</p>
                    <p><strong>Thank You!</strong></p>
                </div>
            )}
        </div>
    );
};

export default BarcodeScanner;
